import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const FeatureRequestsPage = lazy(() => import('../components/FeatureRequestsPage'));
const NewFeatureRequestPage = lazy(() => import('../components/NewFeatureRequestPage'));

const FeatureRequestsRoutes: RouteObject[] = [
  {
    path: 'service-requests/feature-requests/new',
    element: <NewFeatureRequestPage />,
  },
  {
    path: 'service-requests/feature-requests',
    element: <FeatureRequestsPage />,
  },
];

export default FeatureRequestsRoutes;
